// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1Gdhp","consentsList":"PatientConsents_consentsList__3opG1","consentsListEmpty":"PatientConsents_consentsListEmpty__pOxAl"};